export default __webpack_public_path__ + "static/media/dice_inactive.ed3a995e.svg";